import { useEffect, useState } from 'react';
import { fetchLeadProcessingDetails,sendForReferralPayout,getReferralPayout } from '../../src/store/slices/insurance';
import { useDispatch, useSelector } from 'react-redux';
import { CURRENCY_SYMBOL } from '../config/constant';
import LeadHistoryModal from '../../src/lead/common/LeadHistoryModal';
import { useLanguage } from "../../src/context/LanguageContext";
import { useParams } from 'react-router-dom';
import { MANAGER_LEVEL_IDS, LEAD_TYPE_WEB, LEAD_TYPE_CRM,COUNTRY_CODE,APP_COUNTRY } from '../../src/config/constant';
import secureStorage from "@src/config/encrypt"; 
import { getMasterConfig } from '../../src/store/slices/common';
import { toast } from "react-toastify"; 
import { Tooltip as TooltipLite } from 'react-tooltip';
import FullPageLoader from '../../src/common/FullPageLoader';
import * as HELPER from "../../src/config/helper";
import moment from "moment";
import ConfirmPopUp from '../../src/common/ConfirmPopUp'; 

const LoanRibbenBox = (props: any) => {
  const { id } = useParams<{ id: string }>()
  const dispatch: any = useDispatch();
  const [viewTimeLine, setViewTimeLine] = useState(false);
  const [selectedRemarkLead, setSelectedRemarkLead] = useState<any>(0);
  // eslint-disable-next-line
  const [masterConfig, setMasterConfig] = useState<any>({});
  // let [formData, setFormData] = useState<any>({});
  // eslint-disable-next-line
  const [showSelectedAssignSave, setShowSelectedAssignSave] = useState<any>('');
  const [tipOpen4, setTipOpen4] = useState(false);
  const [loading, setLoading] = useState<boolean>(false);
   // eslint-disable-next-line
  const [trigger, setTrigger] = useState(0);

  const insuranceDetails = useSelector((state: any) => state.insurance.leadDetail);
  // const LeadEmiDetails = useSelector((state: any) => state.insurance.leadEmiDetail);
  const {translations} = useLanguage();
  const queryParams = useParams();
  const authUserInfo = secureStorage.getItem("authUserInfo");
  const [showConfirmation, setShowConfirmation] = useState(false);
  const [referralButtonText, setReferralButtonText] = useState("");
  const [isButtonDissbale,setIsbuttonDissable] = useState(false);
  const isLeadDetailLoaderControlled = COUNTRY_CODE === APP_COUNTRY.APP_TYPE_PH && typeof props.setLeadDetailLoading === 'function';
  const setPageLoading = (isLoading: boolean) => {
    if (isLeadDetailLoaderControlled) {
      props.setLeadDetailLoading(isLoading);
      return;
    }

    setLoading(isLoading);
  };
 
  useEffect(() => {
    if (translations?.Insurance?.PAY_REFERRAL_MARKUP) {
      setReferralButtonText(translations.Insurance.PAY_REFERRAL_MARKUP);
    }
  }, [translations]);

  useEffect(() => {
    const bodyClick = () => {
      setTipOpen4(false);
    };
    document.addEventListener('mousedown', bodyClick);

    return () => {
      document.removeEventListener('mousedown', bodyClick);
    };
  }, []);

  useEffect(() => {
    if (queryParams?.id) {
      setPageLoading(true);
      dispatch(fetchLeadProcessingDetails({ id: queryParams?.id }))
      .finally(() => setPageLoading(false));
      getMasterConfigApi();
    }
    // eslint-disable-next-line
  }, [queryParams?.id,trigger,props.callReloadApi]);

  /**
     * HAHNDLE HISTORY POPUP
     * @param type 
     * @param leadId 
     */
  const handleViewTimeLine = (type: boolean, leadId: any) => {
    setViewTimeLine(type);
    setSelectedRemarkLead(leadId);

  }

  // const getDueDateClass = (lead: any): string => {
  //   const today = new Date();
  //   const dueDate = new Date(lead?.next_due_date);

  //   if (!lead?.next_due_date) return ""; // no date, no class

  //   if (today > dueDate) {
  //     return "txt-highlight";
  //   }

  //   const daysUntilDue =
  //     (dueDate.getTime() - today.getTime()) / (1000 * 60 * 60 * 24);

  //   if (daysUntilDue <= 14) {
  //     // Upcoming within 14 days: yellow
  //     return "txt-yellow";
  //   }

  //   // Default: no class
  //   return "";
  // };

   const getMasterConfigApi = async () => {
      setPageLoading(true);
      try {
        const res: any = await dispatch(getMasterConfig());
        if (res && res.status === 200) {
          if (res.data) {
            setMasterConfig(res.data);
           // setListSort(res.data['lead_sorting_filter'][0]);
          }
        }
      } finally {
        setPageLoading(false);
      }
    }

    // const handleChange = (fieldKey: string, selected: any) => {
    //   setFormData((prev: any) => ({
    //     ...prev,
    //     [fieldKey]: selected.value,
    //   }));
    //   setShowSelectedAssignSave(fieldKey);
    // };


  // const saveAssignLeadHandler = (params: { lead_id: any, action: string }) => {
  //   if (params.action === "save") {
  //     setLoading(true);
  //     updatePaymentMethod({
  //       lead_id: params.lead_id,
  //       payment_method: formData.payment_method,
  //     }).then((res: any) => {
  //       if (res?.status === 200) {
  //         toast.success(res.message);
  //         setShowSelectedAssignSave('');
  //         setTrigger(trigger + 1);
  //         props.setCallReloadApi(props.callReloadApi+1);
  //       }
  //     }).finally(() => {
  //       setLoading(false);
  //     });
  //   }
  //   else if (params.action === "cancel") {
  //     setFormData({ payment_method: insuranceDetails[0]?.payment_method || 1 });
  //     setShowSelectedAssignSave('');
  //   }
  // };

  const handleSubmit = async () => {
    try{
      setPageLoading(true);
      const res: any = await sendForReferralPayout({
        lead_id: +insuranceDetails[0]?.leadId
      });
      if (res?.status === 200) {
        toast.success(res.message);
        setShowConfirmation(false);
        await getReferralPayoutData(false);
      }
    }catch (error) {
      console.error("Error while updating EMI detail:", error);
    }finally {
        setPageLoading(false);
    }
  }

  const getReferralPayoutData = async (showLoader = true) => {
    try{
      if (showLoader) setPageLoading(true);
      const res: any = await getReferralPayout({
        lead_id: id
      });
      if (res?.status === 200) {
        if(res.data.is_referral_payout_sent){
          setReferralButtonText(translations.Insurance?.['SENT_TO_REFERRAL_PAYOUT']);
          setIsbuttonDissable(true);
        }else{
          setReferralButtonText(translations.Insurance.PAY_REFERRAL_MARKUP);
          setIsbuttonDissable(false)
        }
      }
    }catch (error) {
      console.error("Error while updating EMI detail:", error);
    }finally {
      if (showLoader) setPageLoading(false);
    }
  }

  useEffect(() => {
    if (translations?.Insurance) {
      getReferralPayoutData(!isLeadDetailLoaderControlled);
    }
    // eslint-disable-next-line
  }, [translations]);

  return (
    <>
    {!isLeadDetailLoaderControlled && <FullPageLoader show={loading} />}
    {showConfirmation === false ? ("") : (
        <ConfirmPopUp
            confirmNo={() => setShowConfirmation(false)}
            confirmYes={handleSubmit}
            message={`Are You Sure, You Want To Pay Referral Markup?`}
            isConfirmNotVisible={true} 
            from={"EmiComponent"}
        />
    )}
    <div className="lead-detail-top-ribben">
      <div className="top-heading top-heading-btn">
        <h1>{insuranceDetails[0]?.customer_name || 'NA'} : {insuranceDetails[0]?.policy_no || 'NA'}</h1>
        {
          Number((insuranceDetails[0]?.referral_markup || 0)) > 0 &&
          <button className="btn-line btn-export referall-button" onClick={() => setShowConfirmation(true)} disabled={props?.isReferralButtonDisabled || isButtonDissbale}>
            <i className="ic-check m-sm-r"></i>
            {referralButtonText || translations.commonMsg?.loading}
          </button>
        }
        <button className="btn-line btn-export" onClick={() => handleViewTimeLine(true, insuranceDetails[0]?.leadId)}>
          <i className="ic-Call-history m-sm-r"></i>
          {translations.Insurance?.['View History'] || translations.commonMsg?.loading}
        </button>
      </div>
        {
          COUNTRY_CODE === APP_COUNTRY.APP_TYPE_PH &&
          <>
            <div className="vechile-policy-detail">
              {/* Customer Details */}
              <div className="policy-detail-txt">
                
                <h3>{translations.Insurance?.['Customer Details'] || translations.commonMsg?.loading}</h3>
                <ul>
                  <li>
                    <label>{translations.RuleEngine?.['Mobile_No'] || translations.commonMsg?.loading}</label>
                    <span>{insuranceDetails[0]?.customer_mobile || 'NA'}</span>
                  </li>
                  <li>
                    <label>{translations.RuleEngine?.['Email'] || translations.commonMsg?.loading} </label>
                    <span title={insuranceDetails[0]?.customer_email || 'NA'}>{insuranceDetails[0]?.customer_email || 'NA'}</span>
                  </li>
                  <li>
                    <label> {translations.Insurance?.['CUSTOMER_TYPE'] || translations.commonMsg?.loading}</label>
                    <span> {insuranceDetails[0]?.customer_type_name || 'NA'}</span>
                  </li>
                  <li>
                    <label> {translations.Insurance?.['PAYMENT_TERM'] || translations.commonMsg?.loading}</label>
                    <span>{insuranceDetails[0]?.payment_term_name || 'NA'}</span>
                  </li>
                  <li>
                    <label> {translations.Insurance?.['PAYMENT_TENURE'] || translations.commonMsg?.loading}</label>
                    <span>{insuranceDetails[0]?.payment_tenure_name || 'NA'}</span>
                  </li>
                  <li>
                    <label> {translations.Insurance?.['POLICY_CODE'] || translations.commonMsg?.loading}</label>
                    <span>{insuranceDetails[0]?.policy_code || '-'}</span>
                  </li>
                </ul>
              </div>

              {/* Vehicle Details */}
              <div className="policy-detail-txt vehicle-detail-txt p-lg-l">
                <h3>{translations.Insurance?.['Car Details'] || translations.commonMsg?.loading}</h3>
                <ul>
                  <li>
                    <label> {translations.Insurance?.['Vehicle'] || translations.commonMsg?.loading}</label>
                    <span title={`${insuranceDetails[0]?.make_name}  ${insuranceDetails[0]?.model_name}  ${insuranceDetails[0]?.version_name}`}> 
                    {(insuranceDetails[0]?.make_name || '') + ' ' + (insuranceDetails[0]?.model_name || '') + ' ' + (insuranceDetails[0]?.version_name || '') || 'NA'}</span>
                  </li>
                  <li>
                    <label> {translations.Insurance?.['MODEL_YEAR'] || translations.commonMsg?.loading} </label>
                    <span>{insuranceDetails[0]?.make_year || 'NA'}</span>
                  </li>
                  <li>
                    <label> {translations.Insurance?.['Plate Number'] || translations.commonMsg?.loading} </label>
                    <span> {insuranceDetails[0]?.plate_no || 'NA'}</span>
                  </li>
                </ul>
              </div>

              {/* Insurer & Premium Details */}
              <div className="policy-detail-txt premium-details p-lg-l">
                <h3> {translations.Insurance?.['INSURER_PREMIUM_DETAILS'] || translations.commonMsg?.loading}</h3>
                <ul>
                  <li>
                    <label>{translations.Insurance?.['Insurance Partner'] || translations.commonMsg?.loading}</label>
                    <span>{insuranceDetails[0]?.insurer_name || 'NA'}</span>
                  </li>
                  <li>
                    <label> {translations.Insurance?.['Insurance Type'] || translations.commonMsg?.loading}</label>
                    <span>{insuranceDetails[0]?.lead_type_name || 'NA'}</span>
                  </li>
                  <li>
                    <label> {translations.Insurance?.['TOTAL_PREMIUM'] || translations.commonMsg?.loading} </label>
                    <span>{insuranceDetails[0]?.total_premium ? HELPER.addCurrencyFormatting(Number(insuranceDetails[0].total_premium).toFixed(2)) : 'NA'}</span>

                  </li>
                  <li>
                    <label>{translations.Insurance?.['EFFECTIVITY_DATE'] || translations.commonMsg?.loading}</label>
                    <span>
                      {insuranceDetails[0]?.policy_start_date ? moment(insuranceDetails[0].policy_start_date).format('DD MMM, YYYY') : 'NA'}
                    </span>
                  </li>
                  <li>
                    <label> {translations.Insurance?.['EXPIRY_DATE'] || translations.commonMsg?.loading}</label>
                    <span>{insuranceDetails[0]?.policy_end_date ? moment(insuranceDetails[0].policy_end_date).format('DD MMM, YYYY') : 'NA'}</span>
                  </li>
                  <li>
                    <label> {translations.Insurance?.['BALANCE_AMOUNT'] || translations.commonMsg?.loading}</label>
                    <span>{`${HELPER.addCurrencyFormatting(Number((insuranceDetails[0]?.total_premium - insuranceDetails[0]?.received_amount).toFixed(2))) }`}</span>
                  </li>
                  {/* <li>
                    <label> {translations.Insurance?.['DUE_DATE'] || translations.commonMsg?.loading}</label>
                  <span className={getDueDateClass(insuranceDetails[0])}>
                      {insuranceDetails[0]?.next_due_date
                        ? moment(insuranceDetails[0].next_due_date).format("DD MMM, YYYY")
                        : ""}
                    </span>
                      {insuranceDetails[0]?.overdue_day_count >= 1 && (
                        <span className="overdue-day-bg">{insuranceDetails[0]?.overdue_day_count || 'NA'} days overdue</span>
                      )}
                  </li> */}
                    {
                      props.isLeadFromAgency &&
                      <li>
                        <label> {translations.Insurance?.['AGENT_COMMISSION'] || translations.commonMsg?.loading}</label>
                        <span>{`${HELPER.addCurrencyFormatting(Number((insuranceDetails[0]?.agent_commision || 0).toFixed(2))) }`}</span>
                      </li>
                    }
                    {
                      Number((insuranceDetails[0]?.referral_markup || 0)) > 0 &&
                      <li>
                        <label> {translations.Insurance?.['REFERRAL_MARKUP'] || translations.commonMsg?.loading}</label>
                        <span>{`${HELPER.addCurrencyFormatting(Number((insuranceDetails[0]?.referral_markup || 0).toFixed(2))) }`}</span>
                      </li>
                    }
                    {
                      props.isLeadFromAgency && 
                      <li>
                        <label> {translations.Insurance?.['COLLECTION_AMOUNT'] || translations.commonMsg?.loading}</label>
                        <span>
                          {HELPER.addCurrencyFormatting((Number(insuranceDetails[0]?.total_premium || 0) - Number(insuranceDetails[0]?.agent_commision || 0)).toFixed(2))}
                        </span>
                      </li>
                    }
                </ul>
              </div>

              {/* Lead Details */}
              <div className="policy-detail-txt policy-lead-detail p-lg-l">
                <h3> {translations.Insurance?.['LEAD_DETAILS'] || translations.commonMsg?.loading}</h3>
                <ul>
                  <li>
                    <label> {translations.Insurance?.['CREATED_BY'] || translations.commonMsg?.loading} </label>
                    <span title={insuranceDetails[0]?.created_by_name || 'NA'}>{insuranceDetails[0]?.created_by_name || 'NA'}</span>
                  </li>
                  <li>
                    <label> {translations.Insurance?.['NEXT_FOLLOW_UP'] || translations.commonMsg?.loading}</label>
                    <span title={insuranceDetails[0]?.followup_date ? moment(insuranceDetails[0].followup_date).format("DD MMM, YYYY hh:mm A") : 'NA'}>{insuranceDetails[0]?.followup_date ? moment(insuranceDetails[0].followup_date).format("DD MMM, YYYY hh:mm A") : 'NA'}</span>
                  </li>
                  <li>
                    <label> {translations.Insurance?.['Hierarchy'] || translations.commonMsg?.loading} </label>
                    <span>{insuranceDetails[0]?.created_by_name || 'NA'}</span>
                    {
                      ![LEAD_TYPE_WEB, LEAD_TYPE_CRM].includes(insuranceDetails[0]?.lead_type_id) &&
                      <span onClick={() => { setTipOpen4(true); }} data-tooltip-id="my-tooltip-4" title="" className="tooltio-ic"><i className="ic-info-icon1"></i>
                      </span>
                    }       
                  </li>
                  <li>
                    <label> {translations.commonMsg?.['status'] || translations.commonMsg?.loading} </label>
                    <span>{insuranceDetails[0]?.status_name || 'NA'}</span>
                  </li>
                {MANAGER_LEVEL_IDS.includes(authUserInfo?.user_data?.assigned_role_ids) && (
                  <li>
                    <label> {translations.RuleEngine?.['Source Type'] || translations.commonMsg?.loading} </label>
                    <span title = {`${insuranceDetails[0]?.source_type}`}>{insuranceDetails[0]?.source_type}</span>
                  </li>
                  )}
                  <li>
                    <label> {translations.Insurance?.['Insurance ID'] || translations.commonMsg?.loading}</label>
                    <span>INS{insuranceDetails[0]?.leadId}</span>
                  </li>
                </ul>
              </div>
            </div>
          </>
        }
        {
          COUNTRY_CODE === APP_COUNTRY.APP_TYPE_ID &&
          <>
            <div className="vechile-policy-detail">
              {/* Customer Details */}
              <div className="policy-detail-txt policy-detail-txt-id">
                
                <h3>{translations.Insurance?.['Customer Details'] || translations.commonMsg?.loading}</h3>
                <ul>
                  <li>
                    <label>{translations.RuleEngine?.['Mobile_No'] || translations.commonMsg?.loading}</label>
                    <span>{insuranceDetails[0]?.customer_mobile || 'NA'}</span>
                  </li>
                  <li>
                    <label>{translations.RuleEngine?.['Email'] || translations.commonMsg?.loading} </label>
                    <span title={insuranceDetails[0]?.customer_email || 'NA'}>{insuranceDetails[0]?.customer_email || 'NA'}</span>
                  </li>
                </ul>
              </div>

              {/* Vehicle Details */}
              <div className="policy-detail-txt premium-details p-lg-l">
                <h3>{translations.Insurance?.['Car Details'] || translations.commonMsg?.loading}</h3>
                <ul>
                  <li>
                    <label> {translations.Insurance?.['VEHICLE_MMV'] || translations.commonMsg?.loading}</label>
                    <span title={`${insuranceDetails[0]?.make_name}  ${insuranceDetails[0]?.model_name}  ${insuranceDetails[0]?.version_name}`}> 
                    {(insuranceDetails[0]?.make_name || '') + ' ' + (insuranceDetails[0]?.model_name || '') + ' ' + (insuranceDetails[0]?.version_name || '') || 'NA'}</span>
                  </li>
                  <li>
                    <label> {translations.Insurance?.['USAGE_TYPE'] || translations.commonMsg?.loading} </label>
                    <span> {insuranceDetails[0]?.usage_type || 'NA'}</span>
                  </li>
                  <li>
                    <label> {translations.Insurance?.['NUMBER_OF_ACCESSORIES'] || translations.commonMsg?.loading} </label>
                    <span> {insuranceDetails[0]?.accessories_count || 'NA'}</span>
                  </li>
                  <li>
                    <label> {translations.Insurance?.['MODEL_YEAR'] || translations.commonMsg?.loading} </label>
                    <span>{insuranceDetails[0]?.make_year || 'NA'}</span>
                  </li>
                  <li>
                    <label> {translations.Insurance?.['VEHICLE_FUEL_TYPE'] || translations.commonMsg?.loading} </label>
                    <span> {insuranceDetails[0]?.fuel_type || 'NA'}</span>
                  </li>
                  <li>
                    <label> {translations.Insurance?.['TOTAL_ACCESSORIES_PRICE'] || translations.commonMsg?.loading} </label>
                    <span>{HELPER.addCurrencyFormatting(insuranceDetails[0]?.accessories_price)}</span>
                  </li>
                  <li>
                    <label> {translations.Insurance?.['VEHICLE_CONDITION'] || translations.commonMsg?.loading} </label>
                    <span> {insuranceDetails[0]?.vehicle_condition_name || 'NA'}</span>
                  </li>
                  
                  <li>
                    <label> {translations.Insurance?.['Plate Number'] || translations.commonMsg?.loading} </label>
                    <span> {insuranceDetails[0]?.plate_no || 'NA'}</span>
                  </li>
                </ul>
              </div>

              {/* Insurer & Premium Details */}
              <div className="policy-detail-txt premium-details p-lg-l">
                <h3> {translations.Insurance?.['INSURER_PREMIUM_DETAILS'] || translations.commonMsg?.loading}</h3>
                <ul>
                  <li>
                    <label>{translations.Insurance?.['CREATED_ON'] || translations.commonMsg?.loading}</label>
                    <span>
                      {insuranceDetails[0]?.created_at ? moment(insuranceDetails[0].created_at).format('DD MMM, YYYY') : 'NA'}
                    </span>
                  </li>
                  <li>
                    <label> {translations.Insurance?.['PREMIUM_AMOUNT'] || translations.commonMsg?.loading} </label>
                    <span>{HELPER.addCurrencyFormatting(insuranceDetails[0]?.total_premium)}</span>
                  </li>
                  <li>
                    <label> {translations.Insurance?.['POLICY_HOLDER'] || translations.commonMsg?.loading}</label>
                    <span>{insuranceDetails[0]?.policy_holder || 'NA'}</span>
                  </li>
                  <li>
                    <label>{translations.Insurance?.['INSURER'] || translations.commonMsg?.loading}</label>
                    <span>{insuranceDetails[0]?.insurer_name || 'NA'}</span>
                  </li>
                  <li>
                    <label> {translations.Insurance?.['TENURE'] || translations.commonMsg?.loading}</label>
                    <span>{insuranceDetails[0]?.payment_tenure}{" "}{insuranceDetails[0]?.payment_tenure > 1 ? "Years" : "Year"}</span>
                  </li>
                  <li>
                    <label>{translations.Insurance?.['CUSTOMER_DISCOUNT_PERCENTAGE'] || translations.commonMsg?.loading}</label>
                    <span>{insuranceDetails[0]?.customer_discount_per ? insuranceDetails[0]?.customer_discount_per : 0} %</span>
                  </li>
                  <li>
                    <label> {translations.Insurance?.['INSURANCE_TYPE'] || translations.commonMsg?.loading}</label>
                     <span>
                      {insuranceDetails[0]?.tenure_summary
                        ? insuranceDetails[0].tenure_summary.split(',').map((tenure: string, index: number) => (
                          <div key={index} title={tenure.trim()}>{tenure.trim()}</div>
                        ))
                        : 'NA'}
                    </span>
                  </li>
                  <li>
                    <label> {translations.Insurance?.['INSURANCE_START_DATE'] || translations.commonMsg?.loading}</label>
                    <span>{insuranceDetails[0]?.policy_start_date ? moment(insuranceDetails[0].policy_start_date).format('DD MMM, YYYY') : 'NA'}</span>
                  </li>
                  <li>
                    <label> {translations.Insurance?.['CUSTOMER_DISCOUNT_RP'] || translations.commonMsg?.loading}</label>
                    <span>{HELPER.addCurrencyFormatting(insuranceDetails[0]?.customer_discount)}</span>
                  </li>
                </ul>
              </div>

              {/* Lead Details */}
              <div className="policy-detail-txt policy-lead-detail p-lg-l">
                <h3> {translations.Insurance?.['LEAD_DETAILS'] || translations.commonMsg?.loading}</h3>
                <ul>
                  <li>
                    <label> {translations.Insurance?.['AGENT_NAME_AND_ID'] || translations.commonMsg?.loading} </label>
                    <span title={`${insuranceDetails[0]?.created_by_name || 'NA'} (${insuranceDetails[0]?.created_by_id || 'NA'})`}>{insuranceDetails[0]?.created_by_name || 'NA'} ({insuranceDetails[0]?.created_by_id || 'NA'})</span>
                  </li>
                  {MANAGER_LEVEL_IDS.includes(authUserInfo?.user_data?.assigned_role_ids) && (
                    <li>
                      <label> {translations.RuleEngine?.['Source Type'] || translations.commonMsg?.loading} </label>
                      <span title = {`${insuranceDetails[0]?.source_type}`}>{insuranceDetails[0]?.source_type}</span>
                    </li>
                  )}
                  <li>
                    <label> {translations.Insurance?.['BM_NAME_AND_ID'] || translations.commonMsg?.loading} </label>
                    <span title={`${insuranceDetails[0]?.bm_name || 'NA'} (${insuranceDetails[0]?.bm_id || 'NA'})`}>{`${insuranceDetails[0]?.bm_name || 'NA'} (${insuranceDetails[0]?.bm_id || 'NA'})`}</span>
                  </li>
                  <li>
                    <label> {translations.Insurance?.['Insurance ID'] || translations.commonMsg?.loading}</label>
                    <span>INS{insuranceDetails[0]?.leadId}</span>
                  </li>
                  <li>
                    <label> {translations.Insurance?.['CREATED_BY'] || translations.commonMsg?.loading} </label>
                    <span title={insuranceDetails[0]?.actual_created_by || 'NA'}>{insuranceDetails[0]?.actual_created_by || 'NA'}</span>
                  </li>
                </ul>
              </div>
            </div>
          </>
        }
    </div>
    {viewTimeLine && <LeadHistoryModal viewTimeLine={viewTimeLine} selectedRemarkLead={selectedRemarkLead} handleViewTimeLine={(action: boolean, leadId: any) => handleViewTimeLine(action, leadId)} />}
    
      {
        tipOpen4 && <div className='tooltip-outer'>

          <TooltipLite
            isOpen={tipOpen4}
            className=" react-tooltip-lite"

            id="my-tooltip-4"
            place="bottom"
            clickable={true}
            render={
              () =>
                <div className=" controlled-example tooltip-main">
                  <div className="tooltip-data">

                    <span className="controlled-example_close-button" onClick={() => { setTipOpen4(false); }}><i className="ic-clearclose"></i></span>             
                    <ul className="user-detail">
                      {insuranceDetails[0]?.hierarchy
                        ?.filter((item: any) => item.user_id && item.user_id !== 0)
                        .map((item: any, index: number) => (
                          <div key={index}>
                            <li>
                              <span>{(item.role_name.charAt(0).toUpperCase()+ item.role_name.slice(1)) || 'NA'} ID</span>
                              <label>{item.user_id || 'NA'}</label>
                            </li>
                            <li>
                              <span>{item.role_name.charAt(0).toUpperCase()+ item.role_name.slice(1)} Name</span>
                              <label>{item.user_name || 'NA'}</label>
                            </li>
                          </div>
                        ))}
                    </ul>
                  </div>
                </div>
            }
          />
        </div>
      }
    </>
  );
};

export default LoanRibbenBox;
